import { RootState } from '../../main/store/main.store.ts';
import { createMemoizedSelector } from '../../main/utils/selector/create-memoized-selector.ts';

import { selectCurrentLessonTaskStep } from './current-lesson-task-step.selector.ts';

export const selectCurrentTaskStepViewCount = createMemoizedSelector(
  selectCurrentLessonTaskStep,
  (state: RootState) => state.lesson.taskStepViewCount,
  ({ task, step }, taskStepViewCount): number => {
    if (!task || !step) return 0;

    return taskStepViewCount[task.taskType]?.[step.stepType] || 1;
  }
);
